import { render, staticRenderFns } from "./TicketsList.vue?vue&type=template&id=12d36286&scoped=true"
import script from "./TicketsList.vue?vue&type=script&lang=js"
export * from "./TicketsList.vue?vue&type=script&lang=js"
import style0 from "./TicketsList.vue?vue&type=style&index=0&id=12d36286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d36286",
  null
  
)

export default component.exports